import React, { useEffect, useState } from "react";
import { Box, Container, Typography, useTheme, alpha } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import HomeIcon from "@mui/icons-material/Home";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const data = [
  {
    title: "Our Story",
    text: "AtHomeGeriCare was born from a deeply personal journey — caring for loved ones from thousands of miles away. The anxiety, the uncertainty, and the helplessness inspired a mission to create care that families can truly trust.",
    icon: PeopleIcon,
  },
  {
    title: "Our Belief",
    text: "We believe healing happens best at home. Familiar surroundings bring comfort, dignity, and emotional stability that no institution can replace.",
    icon: HomeIcon,
  },
  {
    title: "Our Expertise",
    text: "With decades of combined experience in healthcare leadership and hospital operations, we blend compassion with professional excellence.",
    icon: EmojiEventsIcon,
  },
  {
    title: "Our Caregivers",
    text: "Every caregiver is background-verified, certified, and carefully matched — because trust is not optional when it comes to family.",
    icon: HealthAndSafetyIcon,
  },
  {
    title: "Our Promise",
    text: "Especially for NRIs, we become your eyes, ears, and support system — ensuring peace of mind no matter where you are in the world.",
    icon: AccessTimeIcon,
  },
];

const SectionThree = ({ storyRef }) => {
  const theme = useTheme();
  const [active, setActive] = useState(0);

  useEffect(() => {
    const sections = document.querySelectorAll(".story-block");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(Number(entry.target.dataset.index));
          }
        });
      },
      { threshold: 0.6 }
    );

    sections.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={storyRef}
      sx={{
        background: "#fafafa",
        py: { xs: 10, md: 16 },
        scrollMarginTop: "110px",
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Typography
          variant="h2"
          align="center"
          sx={{
            fontWeight: 800,
            mb: 3,
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          Our Journey
        </Typography>

        <Typography
          align="center"
          sx={{
            color: "text.secondary",
            fontSize: "1.15rem",
            mb: 12,
          }}
        >
          A care philosophy built on empathy, trust, and responsibility
        </Typography>

        {/* Story Blocks */}
        {data.map((item, index) => {
          const Icon = item.icon;
          const isActive = active === index;

          return (
            <Box
              key={index}
              className="story-block"
              data-index={index}
              sx={{
                position: "relative",
                mb: 12,
                opacity: isActive ? 1 : 0.35,
                transform: isActive ? "translateY(0)" : "translateY(40px)",
                transition: "all 0.8s ease",
              }}
            >
              {/* Watermark Icon */}
              <Box
                sx={{
                  position: "absolute",
                  top: "-30px",
                  right: 0,
                  fontSize: 140,
                  color: alpha(theme.palette.primary.main, 0.08),
                }}
              >
                <Icon fontSize="inherit" />
              </Box>

              {/* Title */}
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                }}
              >
                {item.title}
              </Typography>

              {/* Divider */}
              <Box
                sx={{
                  width: 60,
                  height: 4,
                  background: theme.palette.primary.main,
                  mb: 3,
                }}
              />

              {/* Text */}
              <Typography
                sx={{
                  fontSize: "1.15rem",
                  lineHeight: 1.9,
                  color: "text.secondary",
                  maxWidth: "90%",
                }}
              >
                {item.text}
              </Typography>
            </Box>
          );
        })}
      </Container>
    </Box>
  );
};

export default SectionThree;

// import React from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   styled,
//   alpha,
// } from "@mui/material";
// import { motion } from "framer-motion";

// const StorySection = styled(Box)(({ theme }) => ({
//   padding: theme.spacing(10, 0),
//   backgroundColor: "#f8f9fa",
//   position: "relative",
//   overflow: "hidden",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     height: "100%",
//     background:
//       "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
//     zIndex: 0,
//   },
// }));

// const TimelineContainer = styled(Box)(({ theme }) => ({
//   position: "relative",
//   paddingLeft: theme.spacing(4),
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     left: "30px",
//     top: 0,
//     bottom: 0,
//     width: "4px",
//     background: "linear-gradient(to bottom, #667eea, #764ba2)",
//     borderRadius: "2px",
//     [theme.breakpoints.down("sm")]: {
//       left: "20px",
//     },
//   },
// }));

// const TimelineItem = styled(Card)(({ theme }) => ({
//   marginBottom: theme.spacing(4),
//   position: "relative",
//   border: "none",
//   borderRadius: "20px",
//   boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
//   transition: "all 0.4s ease",
//   backgroundColor: "white",
//   overflow: "visible",
//   "&:hover": {
//     transform: "translateY(-10px)",
//     boxShadow: "0 25px 60px rgba(102, 126, 234, 0.15)",
//   },
// }));

// const CardHeader = styled(Box)(({ theme }) => ({
//   padding: theme.spacing(3),
//   borderBottom: `1px solid ${alpha("#667eea", 0.1)}`,
//   background:
//     "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
//   borderRadius: "20px 20px 0 0",
// }));

// const Title = styled(Typography)(({ theme }) => ({
//   fontSize: "1.5rem",
//   fontWeight: 700,
//   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   fontFamily: "'Poppins', sans-serif",
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "1.25rem",
//   },
// }));

// const ContentText = styled(Typography)(({ theme }) => ({
//   fontSize: "1rem",
//   lineHeight: 1.8,
//   color: "#5d6d7e",
//   fontFamily: "'Inter', sans-serif",
//   fontWeight: 400,
// }));

// // Separate component for timeline item to use hooks properly
// const TimelineItemComponent = ({ item, index }) => {
//   return (
//     <motion.div
//       initial={{ opacity: 0, x: -50 }}
//       whileInView={{ opacity: 1, x: 0 }}
//       viewport={{ once: true, amount: 0.1 }}
//       transition={{ duration: 0.6, delay: index * 0.1 }}
//     >
//       <TimelineItem>
//         <Box
//           sx={{
//             position: "absolute",
//             left: "-44px",
//             top: "30px",
//             width: "20px",
//             height: "20px",
//             borderRadius: "50%",
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             border: "4px solid white",
//             boxShadow: "0 0 0 4px rgba(102, 126, 234, 0.2)",
//             zIndex: 2,
//             [(theme) => theme.breakpoints.down("sm")]: {
//               left: "-34px",
//               width: "16px",
//               height: "16px",
//             },
//           }}
//         />
//         <CardHeader>
//           <Title variant="h6">{item.title}</Title>
//         </CardHeader>
//         <CardContent sx={{ padding: 3 }}>
//           <ContentText>{item.content}</ContentText>
//         </CardContent>
//       </TimelineItem>
//     </motion.div>
//   );
// };

// const SectionThree = ({ storyRef }) => {
//   const boxContents = [
//     {
//       title: "Our Story",
//       content:
//         "I found this company based on my own journey of caring for my grandmother and mother-in-law from thousands of miles away. The complexities of finding the right care and the constant worry about their well-being were overwhelming. Through these personal trials, I realized that there had to be a better way—one that provided peace of mind to families and ensured the comfort of our loved ones.",
//     },
//     {
//       title: "Our Philosophy",
//       content:
//         "I believe that elderly care should not mean uprooting our loved ones from the comfort of their home. While care homes can sometimes be a solution, we need to understand that it's often difficult for the elderly to adjust to new environments. At AtHomeGeriCare, we know that the heart heals best at home. That's why we focus on providing in-home care, allowing your loved ones to age gracefully in the place they know and love.",
//     },
//     {
//       title: "Our Expertise",
//       content:
//         "AtHomeGeriCare is built on a foundation of trust, compassion, and professional excellence. Through my journey I met with Subha, a leader in healthcare services with 30 years of experience in hospital management. Together, we have combined our personal and professional experiences to create a service that is more than just care—it's a lifeline for families.",
//     },
//     {
//       title: "Our Caregivers",
//       content:
//         "We are committed to providing only the highest quality care. Our caregivers are thoroughly vetted, with 100% background checks and validated certifications, ensuring that your loved ones are in safe, skilled hands. Each caregiver is carefully matched to meet the specific needs of your family, creating a bond that goes beyond mere assistance.",
//     },
//     {
//       title: "Our Commitment",
//       content:
//         "At AtHomeGeriCare, we are dedicated to walking this journey with you. We understand the unique challenges faced by NRIs and have crafted our services to offer not just solutions but also peace of mind. With us by your side, you can be confident that your loved ones are receiving the care they deserve—compassionate, personalized, and right at home. Let's navigate this path together, ensuring that your loved ones live with dignity and comfort. We're here for you, every step of the way.",
//     },
//   ];

//   return (
//     <StorySection ref={storyRef}>
//       <Container maxWidth="lg">
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.1 }}
//           transition={{ duration: 0.8 }}
//         >
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: "2.5rem", md: "3.5rem" },
//                 fontWeight: 800,
//                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 fontFamily: "'Poppins', sans-serif",
//                 mb: 2,
//               }}
//             >
//               Our Journey
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: "#7f8c8d",
//                 fontWeight: 400,
//                 maxWidth: "600px",
//                 margin: "0 auto",
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               From personal experience to professional excellence
//             </Typography>
//           </Box>

//           <TimelineContainer>
//             {boxContents.map((item, index) => (
//               <TimelineItemComponent key={index} item={item} index={index} />
//             ))}
//           </TimelineContainer>
//         </motion.div>
//       </Container>
//     </StorySection>
//   );
// };

// export default SectionThree;
